module.exports = __webpack_public_path__ + "assets/img/paper_icon_back.a751be08.png";